module.exports = __webpack_public_path__ + "static/media/avalanche.3b566048.svg";